import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/Button';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import { BRAND } from '@/lib/const';
import * as PM from '@/messages/payment';

export type ReturnConfirmationProps = {
  isGuestMode: boolean;
  onBackToMyAccount: () => void;
  onBuyWatch: () => void;
  orderBusinessId: string;
};

const brandDisplayName =
  BRAND.length > 0
    ? BRAND.charAt(0).toUpperCase() + BRAND.slice(1).toLowerCase()
    : BRAND;

export const ReturnConfirmation: FC<ReturnConfirmationProps> = ({
  isGuestMode,
  onBackToMyAccount,
  onBuyWatch,
  orderBusinessId,
}) => {
  return (
    <Flex
      alignItems='center'
      backgroundColor='secondaryLightGrey'
      flexDirection='column'
      gridGap='s200'
      justifyContent='center'
      marginBottom='s100'
      marginLeft={{ md: 's250', xs: 's000' }}
      marginTop='s100'
      padding='s250'
    >
      <Typography as='p' color='black' textAlign='center'>
        <FormattedMessage
          {...PM.paymentMessages.returnConfirmationTitle}
          values={{
            orderNumber: <strong>#{orderBusinessId}</strong>,
          }}
        />
        <br />
        <FormattedMessage
          {...PM.paymentMessages.returnConfirmationFollowUp}
          values={{ brand: brandDisplayName }}
        />
      </Typography>
      <Flex
        alignItems='center'
        flexDirection='column'
        gridGap='s100'
        justifyContent='center'
        width='100%'
      >
        <Button
          data-test-id='OrderReturnViewConfirmationBuyWatch'
          onClick={onBuyWatch}
          size='medium'
          style={{ width: '255px' }}
          type='button'
          variant='primary'
        >
          <FormattedMessage
            {...PM.paymentMessages.returnConfirmationBuyWatch}
          />
        </Button>
        {isGuestMode ? null : (
          <Button
            data-test-id='OrderReturnViewConfirmationBackToAccount'
            onClick={onBackToMyAccount}
            size='medium'
            style={{ width: '255px' }}
            type='button'
            variant='outlined'
          >
            <FormattedMessage
              {...PM.paymentMessages.returnConfirmationBackToAccount}
            />
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
